// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.khkT7zWJ4WC4MOE1 {
	color: var(--lok-color-text-light-default);

	font: var(--lok-typography-body-tiny-default);
	font-family: var(--lok-font-family-inter);
}

.MTZcCV_XFmsGegbb {
	color: var(--lok-color-text-disabled);
	font: var(--lok-typography-body-tiny-default);
	font-family: var(--lok-font-family-inter);
}

.DOYNas0o9Ckd1e3a {
	color: var(--lok-color-text-default);
	border-color: var(--lok-color-background-surface-fore);
	background-color: var(--lok-color-background-surface-fore);
}

.S7Qjw06sDYSzD8ld.S7Qjw06sDYSzD8ld {
	max-width: 370px;
	text-align: center;
	overflow-wrap: break-word;
	font-family: var(--lok-font-family-inter);
}
`, "",{"version":3,"sources":["webpack://./packages/rag/src/components/Cards/components/ProjectsList/ProjectsList.module.css"],"names":[],"mappings":"AAAA;CACC,0CAA0C;;CAE1C,6CAA6C;CAC7C,yCAAyC;AAC1C;;AAEA;CACC,qCAAqC;CACrC,6CAA6C;CAC7C,yCAAyC;AAC1C;;AAEA;CACC,oCAAoC;CACpC,sDAAsD;CACtD,0DAA0D;AAC3D;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;CAClB,yBAAyB;CACzB,yCAAyC;AAC1C","sourcesContent":[".title {\n\tcolor: var(--lok-color-text-light-default);\n\n\tfont: var(--lok-typography-body-tiny-default);\n\tfont-family: var(--lok-font-family-inter);\n}\n\n.blankMessage {\n\tcolor: var(--lok-color-text-disabled);\n\tfont: var(--lok-typography-body-tiny-default);\n\tfont-family: var(--lok-font-family-inter);\n}\n\n.tag {\n\tcolor: var(--lok-color-text-default);\n\tborder-color: var(--lok-color-background-surface-fore);\n\tbackground-color: var(--lok-color-background-surface-fore);\n}\n\n.tooltip.tooltip {\n\tmax-width: 370px;\n\ttext-align: center;\n\toverflow-wrap: break-word;\n\tfont-family: var(--lok-font-family-inter);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `khkT7zWJ4WC4MOE1`,
	"blankMessage": `MTZcCV_XFmsGegbb`,
	"tag": `DOYNas0o9Ckd1e3a`,
	"tooltip": `S7Qjw06sDYSzD8ld`
};
export default ___CSS_LOADER_EXPORT___;
